import * as Yup from 'yup';

 const transactionsSchema = Yup.object().shape({
    date: Yup.string().required('Required'),
    invoiceId: Yup.string().required('Required'),
    status: Yup.string().required('Required'),
    MemberId: Yup.string().required('Required'),
    detailTransactions: Yup.array().of(
        Yup.object().shape({
            ProductId: Yup.string().required('Required'),
            Qty:  Yup.string().required('Required'),
        })
    )
});

export default transactionsSchema